import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unidadpipe'
})
export class UnidadPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(args == ""){
      return value;
    }
    return value.filter(item => (item.alias.indexOf(args) !== -1));
  }

}
